import { Modal, ModalProps } from "@chakra-ui/react";
import React from "react";

export const ZModal: React.FC<ModalProps> = (props) => {
  return <Modal isCentered preserveScrollBarGap={true} {...props} />;
};
